module.exports = __webpack_public_path__ + "static/media/shreya_professional.27408d1e.jpg";